import React from "react";
import { useNavigate } from "react-router-dom";
import styles from "./CallTypleComponent.module.css";
import { LuPhoneOutgoing, LuPhoneIncoming } from "react-icons/lu";

const CallTypeComponent = () => {
  const navigate = useNavigate();

  return (
    <div className={styles.container}>
      <div className={styles.textWrapper}>
        <p className={styles.heading}>
          How would you like to connect?
        </p>
        <p className={styles.subheading}>
          Pick your AI receptionist. We'll match it to your business vibe
        </p>
      </div>

      <div className={styles.cardContainer}>
        {/* Outbound Card */}
      

        {/* Inbound Card */}
        <div className={`${styles.card} ${styles.inboundCard}`}>
          <div className={styles.iconWrapper}>
            <LuPhoneIncoming className={styles.icon} />
          </div>
          <h3 className={styles.title}>Inbound Agent</h3>
          <p className={styles.subtitle}>
  Be there when your customers need you<br />
  Receive calls and handle inquiries in real time
</p>

<hr className={styles.divider} />

<p className={styles.description}>
  Supercharge your customer engagement and boost conversions.<br />
  AI-driven outreach keeps the momentum going.<br/>Focus on scaling-AI's got the rest.
</p>
          <button
            className={styles.selectButton}
            onClick={() => navigate("/inbound")}
          >
            Select
          </button>
        </div>

        <div className={`${styles.card} ${styles.outboundCard}`}>
          <div className={styles.iconWrapper}>
            <LuPhoneOutgoing className={styles.icon} />
          </div>
          <h3 className={styles.title}>Outbound Agent</h3>
          <p className={styles.subtitle}>
  Be there when your customers need you<br />
  Receive calls and handle inquiries in real time
</p>

<hr className={styles.divider} />

<p className={styles.description}>
  Supercharge your customer engagement and boost conversions.<br />
  AI-driven outreach keeps the momentum going.<br/>Focus on scaling-AI's got the rest.
</p>
          <button
            className={styles.selectButton}
            onClick={() => navigate("/outbound")}
          >
            Select
          </button>
        </div>


      </div>
    </div>
  );
};

export default CallTypeComponent;